<div class="login-container">
    <form class="form-container" [formGroup]="loginForm">
        <div class="version">v{{ version }}</div>
        <fa-icon class="authenticate-icon" [icon]="faKey"></fa-icon>

        <a class="link" role="button" (click)="forgottenPassword()">VOUS N'AVEZ PAS VOTRE MOT DE PASSE ? CLIQUER ICI.</a>

        <mat-form-field class="login">
            <mat-label>Identifiant</mat-label>
            <input
                matInput
                data-input-login
                type="text"
                formControlName="loginFormControl"
                name="identifiant"
                [(ngModel)]="login.login"
                required
                (keyup.enter)="authenticate()"
                autocomplete="false" />
        </mat-form-field>

        <mat-form-field class="password">
            <mat-label>Mot de passe</mat-label>
            <input
                matInput
                data-input-password
                [type]="passwordTextHidden ? 'password' : 'text'"
                formControlName="passwordFormControl"
                name="password"
                [(ngModel)]="login.password"
                required
                (keyup.enter)="authenticate()"
                autocomplete="false" />
            <button
                mat-icon-button
                matSuffix
                (click)="passwordTextHidden = !passwordTextHidden"
                class="visibility-button"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="passwordTextHidden"
                type="button">
                @if (passwordTextHidden) {
                    <fa-icon [icon]="showPasswordIcon" class="password-visibility-icon" matTooltip="Afficher le mot de passe en clair" matTooltipPosition="right"></fa-icon>
                } @else {
                    <fa-icon [icon]="hidePasswordIcon" class="password-visibility-icon" matTooltip="Masquer le mot de passe" matTooltipPosition="right"></fa-icon>
                }
            </button>
        </mat-form-field>

        <button mat-raised-button class="accent-button form-connection-button" [disabled]="!loginForm.valid" (click)="authenticate()">Connexion</button>
        <p [ngClass]="{ hidden: !authenticationFailed }" class="error"><span>Échec de l'authentification</span></p>
        <p [ngClass]="{ hidden: !authorizationFailed }" class="error"><span>L'utilisateur n'a pas les droits d'accèder à cette interface</span></p>
    </form>
</div>
